module.exports = "<button #button class=\"btn btn-default btn-rounded line-n\"\n        [ngClass]=\"addClass\"\n        [disabled]=\"isDisabled\"\n        (click)=\"handleClick($event)\"\n>\n    <i class=\"fa fa-trash-o pr-0\" *ngIf=\"isEmpty\"></i>\n    <i class=\"fi fa fa-trash-o\" *ngIf=\"!isEmpty\"></i>\n    {{ btnText }}\n</button>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/delete-btn/delete-btn.html
// module id = ./web/modern/components/buttons/delete-btn/delete-btn.html
// module chunks = 0